import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-arrow",
  "use": "default-arrow-usage",
  "viewBox": "0 0 30 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 20\" id=\"default-arrow\"><g fill-rule=\"evenodd\" transform=\"translate(0 -1)\"><rect width=\"30\" height=\"3\" y=\"10\" rx=\"1.5\" /><path d=\"M29.85 11.228c.113.488-.02 1.02-.4 1.4l-7.778 7.779a1.5 1.5 0 11-2.122-2.122l7.057-7.057-7.057-7.056a1.5 1.5 0 012.122-2.122l7.778 7.778c.38.38.513.913.4 1.4z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol